import { MainTitle, Underline } from '@/components';
import DonationStyle from './index.module.scss';
import { Donations } from '@/utils';
import { DONOR_COLLECTION } from '@/constants';
import { HoverUnderlineWrapper } from '@/components';
import getConfig from 'next/config';
import Image from 'next/image';

const { publicRuntimeConfig } = getConfig();

const Donation = () => {
  const donations = new Donations({ collections: DONOR_COLLECTION });
  const staticImageLoader = ({ src }) => {
    return `${publicRuntimeConfig.assetPrefix}${src}`;
  };
  return (
    <div className={DonationStyle.container}>
      <MainTitle>기증자 아카이브</MainTitle>
      <ul className={DonationStyle.gridContainer}>
        {donations.sortMajorCollections.map((collection, index) => {
          const { noImage } = collection;
          const imageSrc = donations.getImageSrc(collection);
          return (
            <li className={DonationStyle.gridItem} key={collection.item}>
              {noImage ? (
                <Image className={DonationStyle.defaultImage} src={imageSrc} loader={staticImageLoader} alt={'donation'} width={80} height={80} unoptimized={true} />
              ) : (
                <Image className={DonationStyle.donationImage} src={imageSrc} loader={staticImageLoader} alt={'donation'} width={300} height={200} unoptimized={true} />
              )}
              <div className={DonationStyle.donorName}>{collection.donor}님</div>
              <div className={DonationStyle.itemName}>{collection.item}</div>
            </li>
          );
        })}
        <li className={DonationStyle.applicationInformation}>
          <div>
            <div className={DonationStyle.description}>기증을 희망하시는 경우, 기증 신청서를 작성하여 아래 이메일로 문의주시기 바랍니다.</div>
            <div className={DonationStyle.email}>ncm@nexoncomputermuseum.org</div>
            <HoverUnderlineWrapper underlineColor={'#E2FF7C'} height={'1'}>
              <Underline>
                <a className={DonationStyle.formDownloadButton} href={'/static/files/NCM_기증신청서_양식.pdf'} download={'NCM_기증신청서_양식'}>
                  기증 신청서 다운로드
                </a>
              </Underline>
            </HoverUnderlineWrapper>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Donation;
